module.exports = __webpack_public_path__ + "static/media/fa-solid-900.acf50f59.ttf";